import PopupError from "../components/common/Popup/PopupError";
import PopupOk from "../components/common/Popup/PopupOk";
import Swal from "sweetalert2";
import { endPoints } from "../const/endPoints";
import { types } from "../context/types/types";
import {
  fetchWithoutToken,
  fetchWithRefreshToken,
  fetchWithToken,
} from "../helpers/fetch";

export const startLogin = (userOrEmail, password) => {
  return async (dispatch) => {
    const resp = await fetchWithoutToken(
      endPoints.signin,
      { userOrEmail, password },
      "POST"
    );
    const body = await resp.json();
    if (resp.status === 200) {
      localStorage.setItem("at", body.access_token);
      localStorage.setItem("rt", body.refresh_token);
      const user = await getUser();
      
      // Verificar si el usuario está inactivo
      if (user.isActive === false) {
        localStorage.removeItem("at");
        localStorage.removeItem("rt");
        PopupError("Tu usuario está inactivo. Para reactivar tu cuenta, realiza el pago correspondiente y comunícate con nosotros al correo cenaoz.docencia@gmail.com");
        return dispatch(checkingFinish());
      }
      
      const profileImageUrl = await getProfileImageUrl(user.image);
      user["profileImageUrl"] = profileImageUrl;
      setTimeout(() => {
        dispatch(
          login({
            user,
          })
        );
      }, 1500);
      // Popup de inicio exitoso. Se ejecuta 1.5s antes del dispatch para que el usuario vea el popup.
      Swal.fire({
        html: `
          <div style="text-align: center; padding: 30px 20px;">
            <div style="
              width: 90px;
              height: 90px;
              background: linear-gradient(135deg, #34C759, #30A646);
              border-radius: 50%;
              display: flex;
              align-items: center;
              justify-content: center;
              margin: 0 auto 25px auto;
              position: relative;
              box-shadow: 
                0 8px 25px rgba(52, 199, 89, 0.25),
                inset 0 1px 0 rgba(255, 255, 255, 0.3);
            ">
              <div style="
                width: 28px;
                height: 16px;
                border-left: 5px solid white;
                border-bottom: 5px solid white;
                transform: rotate(-45deg);
                margin-top: -6px;
                margin-left: 4px;
                border-radius: 0 0 0 2px;
              "></div>
            </div>
            <h2 style="
              color: #1D1D1F; 
              margin: 0; 
              font-size: 22px;
              font-weight: 600;
              font-family: -apple-system, BlinkMacSystemFont, 'SF Pro Display', 'Helvetica Neue', sans-serif;
              letter-spacing: -0.5px;
            ">Inicio de sesión exitoso</h2>
          </div>
        `,
        showConfirmButton: false,
        timer: 1800,
        background: '#fff',
        backdrop: 'rgba(0,0,0,0.1)',
        customClass: {
          popup: 'mac-style-popup'
        }
      });
    } else {
      console.log(body.message);
      PopupError(body.message);
    }
  };
};

export const startRegister = (value, redirectToCourse = null) => {
  console.log('🏁 startRegister - redirectToCourse:', redirectToCourse);
  return async (dispatch) => {
    const resp = await fetchWithoutToken(endPoints.signup, value, "PUT");
    const body = await resp.json();
    console.log(`este es el status ${resp.status}`);
    if (resp.status !== 201) {
      return PopupError(body.message);
    }
    localStorage.setItem("at", body.access_token);
    localStorage.setItem("rt", body.refresh_token);
    const user = await getUser();
    
    // Verificar si el usuario está inactivo
    if (user.isActive === false) {
      localStorage.removeItem("at");
      localStorage.removeItem("rt");
      PopupError("Tu usuario está inactivo. Para reactivar tu cuenta, realiza el pago correspondiente y comunícate con nosotros al correo cenaoz.docencia@gmail.com");
      return;
    }
    
    PopupOk("28rem", "success", "Se registró con éxito. Ahora puede proceder con el pago del curso");
    setTimeout(() => {
      dispatch(
        login({
          user,
        })
      );
      // Redirigir al curso si se especifica, sino a perfil
      console.log('🎯 Redirect decision - redirectToCourse:', redirectToCourse);
      if (redirectToCourse) {
        console.log('✅ Redirecting to course with payment popup:', `/course/${redirectToCourse}?openPayment=true`);
        window.location.href = `/course/${redirectToCourse}?openPayment=true`;
      } else {
        console.log('📂 Redirecting to profile/courses');
        window.location.href = "/profile/courses";
      }
    }, 1500);
  };
};

export const startChecking = () => {
  return async (dispatch) => {
    if (!localStorage.getItem("at") && !localStorage.getItem("rt")) {
      return dispatch(checkingFinish());
    }
    const user = await getUser();
    if (user.statusCode === 401) {
      const refresh = await fetchWithRefreshToken(endPoints.refresh_token);
      const body = await refresh.json();
      if (!refresh.status === 200) {
        return dispatch(checkingFinish());
      }
      localStorage.setItem("at", body.access_token);
      localStorage.setItem("rt", body.refresh_token);
      const user = await getUser();
      if (user.statusCode === 401) {
        return dispatch(checkingFinish());
      }
      if (!user.statusCode) {
        // Verificar si el usuario está inactivo
        if (user.isActive === false) {
          localStorage.removeItem("at");
          localStorage.removeItem("rt");
          PopupError("Tu usuario está inactivo. Para reactivar tu cuenta, realiza el pago correspondiente y comunícate con nosotros al correo cenaoz.docencia@gmail.com");
          return dispatch(checkingFinish());
        }
        
        const profileImageUrl = await getProfileImageUrl(user.image);
        user["profileImageUrl"] = profileImageUrl;
        return dispatch(login({ user }));
      }
    }
    // Verificar si el usuario está inactivo
    if (user.isActive === false) {
      localStorage.removeItem("at");
      localStorage.removeItem("rt");
      PopupError("Tu usuario está inactivo. Para reactivar tu cuenta, realiza el pago correspondiente y comunícate con nosotros al correo cenaoz.docencia@gmail.com");
      return dispatch(checkingFinish());
    }
    
    const profileImageUrl = await getProfileImageUrl(user.image);
    user["profileImageUrl"] = profileImageUrl;
    return dispatch(login({ user }));
  };
};

const checkingFinish = () => ({
  type: types.authLogout,
  payload: {},
});

const login = (user) => ({
  type: types.authLogin,
  payload: user,
});

export const startLogout = () => {
  return async (dispatch) => {
    await fetchWithToken(endPoints.logout, {}, "PUT");
    localStorage.clear();
    PopupOk("28rem", "info", "Sesion cerrada con exito");
    setTimeout(() => dispatch(logout()), 1500);
  };
};

const logout = () => ({ type: types.authLogout, payload: {} });

const getUser = async () => {
  const resp = await fetchWithToken(endPoints.get_user);
  const body = await resp.json();
  return body;
};

const getProfileImageUrl = async (image) => {
  const res = await fetchWithToken(`${endPoints.get_profile_image}/${image}`);
  const url = res.url;
  return url;
};
